"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Item = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column'
});
const Item = exports.Item = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.text.secondary,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1)
}));
//# sourceMappingURL=styles.js.map